// extracted by mini-css-extract-plugin
export default {"link":"KL-z","disabled":"LL-z"};